import { useMemo } from "react";
import { Sparkles } from "lucide-react";
import { quoteForToday } from "@/lib/quotes";

export default function QuoteOfTheDay() {
  const { text, author } = useMemo(() => quoteForToday(new Date()), []);
  const dateLabel = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  return (
    <div
      className="rounded-2xl border-2 border-primary/30 bg-card p-6 sm:p-8 shadow-sm"
      data-testid="quote-of-the-day"
    >
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-3">
        <Sparkles strokeWidth={1.5} className="size-3.5 text-primary" />
        Quote of the day · {dateLabel}
      </div>
      <blockquote
        className="font-display text-xl sm:text-2xl lg:text-3xl font-bold leading-snug tracking-tight"
        data-testid="quote-text"
      >
        &ldquo;{text}&rdquo;
      </blockquote>
      <div
        className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground"
        data-testid="quote-author"
      >
        <span className="h-px w-6 bg-primary/50" />— {author}
      </div>
    </div>
  );
}
